// Shown in a form that needs a child when the banner has none selected.
export function PickChildHint({ darkMode }) {
  return (
    <div className={`p-3 rounded-lg text-sm ${darkMode ? 'bg-yellow-900 text-yellow-200' : 'bg-yellow-50 text-yellow-800'}`}>
      Choose a child at the top of the screen first.
    </div>
  );
}
